import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectSurveyTaskServiceCreateResponseJson } from '@vmspdb/definitions';
import { Paginated } from '@vmspdb/ui/domain';
import * as fromPaginatedSurveyTask from './paginated-survey-task.reducer';

export const selectPaginatedSurveyTaskState =
  createFeatureSelector<fromPaginatedSurveyTask.PaginatedSurveyTaskState>(
    fromPaginatedSurveyTask.paginatedSurveyTaskFeatureKey,
  );

export const selectPaginatedSurveyTasks = createSelector(
  selectPaginatedSurveyTaskState,
  (state): Paginated<ProjectSurveyTaskServiceCreateResponseJson> => state,
);

export const selectPaginatedSurveyTaskItems = createSelector(
  selectPaginatedSurveyTaskState,
  (state) => state.items,
);
